<script>
    import {Line} from 'vue-chartjs'
    //Voor min en max tonen, niet verwijderen
    // eslint-disable-next-line
    import chartjsPluginAnnotation from "chartjs-plugin-annotation"

    export default {
        extends: Line,
        props: {
            chartData: {
                type: Object,
                default: null
            },
            typeChart: {
                type: String,
                default: ''
            },
            component: {
                type: Object,
                default: null
            }
        },
        computed: {
            //Kijken of het pollution of wear is, adhv waardes meegeven
            typeData(){
                //Standaard type wear invullen
                let label = 'Wear'
                let borderColor = '#41b883'
                let data = this.chartData.wear_rates
                let min = this.component.min_wear_rate
                let max = this.component.max_wear_rate

                //Kijken naar type
                if(this.typeChart == 'pollution'){
                    label = 'Pollution'
                    borderColor = '#35495e'
                    data = this.chartData.pollution_rates
                    min = this.component.min_pollution_rate
                    max = this.component.max_pollution_rate
                }
                return {
                    label: label,
                    borderColor: borderColor,
                    data: data,
                    min: min,
                    max: max
                }
            },
            chartDataFormatted() {
                return {
                    labels: this.formatDates(this.chartData.labels),
                    datasets: [
                        {
                            label: this.typeData.label,
                            borderColor: this.typeData.borderColor,
                            data: this.typeData.data
                        }
                    ]
                }
            },
            chartOptions() {
                return {
                    annotation: {
                        annotations: [
                            {
                                type: 'line',
                                mode: 'horizontal',
                                scaleID: 'y-axis-0',
                                value: this.typeData.max,
                                borderColor: 'tomato',
                                borderWidth: 1
                            },
                            {
                                type: 'line',
                                mode: 'horizontal',
                                scaleID: 'y-axis-0',
                                value: this.typeData.min,
                                borderColor: 'tomato',
                                borderWidth: 1
                            }
                        ],
                        drawTime: "afterDraw" // (default)
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: true
                    },
                    scales: {
                        yAxes: [{
                            display: true,
                            ticks: {
                                beginAtZero: true,
                                suggestedMax: 5
                            }
                        }]
                    },
                }
            }
        },
        mounted() {
            this.renderChart(this.chartDataFormatted, this.chartOptions)
        },
        methods:{
            //Date array formatten van Y-M-D naar D/M/Y
            formatDates(dates){
                let returnDate = []
                for(let key in dates){
                    returnDate.push(this.moment(dates[key]).format('D/M/Y'))
                }
                return returnDate
            }
        }
    }
</script>
